module.exports = __webpack_public_path__ + "static/media/hostinger.f10dc23d.webp";